<template>
  <v-container style="width: 100%; padding-bottom: 200px;">
    <v-layout justify-space-between>
      <h3>Create Driver Group</h3>
    </v-layout>
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8 py-3>
          <DriverGroupForm @create="create" :driverGroup="driverGroup"/>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import DriverGroupForm from "@/components/settings/general/driver/DriverGroupForm.vue";
import SimpleCard from "@/components/widget/SimpleCard.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "driver_group_form",
  components: {
    DriverGroupForm
  },
  data: function() {
    return {
      driverGroup: {
        name: "",
        enabled: false,
        vipEligible: false,
        limitToDriverIndicatedBoundary: false,
        autodispatchPenalty: 0,
        callsignPrefix: "",
        includeInEtaPolicy: "always"
      }
    };
  },
  mounted: function() {
  },
  methods: {
    create: async function() {

      console.log("Create");

      if (this.driverGroup.name.length <= 0) {
        alert("Name must not be blank");
      }

      try {
        var url = `${this.$store.state.apiUrl}/driver_group/create`;

        let response = await axios.post(url, this.driverGroup);

        if (response.data.id != 0) {
          window.location.href = `/settings/driver_group/edit/${response.data.id}`;
        }

      } catch {
        print(e,x);
      }
      
    }
  }
};
</script>
